// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3VS3l","actionsCol":"EnrolledClinics_actionsCol__2gNcJ"};